export class Alerta {
    mensagem: string;
    mostraAlerta: boolean;
    nivel?: string;
    constructor(mensagem?: string, nivel?: string) {
        this.mostraAlerta = false;
        this.nivel = nivel ? nivel : 'danger';
        this.mensagem = mensagem != null ? mensagem : '';
    }

    /**
     * Método recebe a mensagem e um opcional de tempo de exibição.
     * O Default é mostrar por 2 segundos.
     * @param segundos ex: 1,2,3..
     */
    public exibeMensagem(mensagem?: string, segundos?: number) {
        if (!!!segundos) {
            segundos = 2;
        }
        if (mensagem != null && mensagem !== '') {
            this.mensagem = mensagem;
        }
        this.mostraAlerta = true;
        setTimeout(() => {
            this.mostraAlerta = false;
        }, segundos * 1000);
    }
}
